module.exports = __webpack_public_path__ + "img/town_1_tn.13855680.jpg";